import {useState} from "react";

import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {AnalyzerTab} from "@/pages/analyzer/Analyzer.types.ts";
import {AnalyzerActionBar} from "@/pages/analyzer/components/AnalyzerActionBar.tsx";
import {AnalyzerChecksForm} from "@/pages/analyzer/components/AnalyzerChecksForm.tsx";
import {AnalyzerReport} from "@/pages/analyzer/components/AnalyzerReport.tsx";
import {AnalyzerResultsHeader} from "@/pages/analyzer/components/AnalyzerResultsHeader.tsx";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerResultsSection.module.scss";

export const AnalyzerResultsSection = () => {
  const {report} = useAnalyzerContext();
  const [activeTab, setActiveTab] = useState<AnalyzerTab>(AnalyzerTab.SELECTION);

  return (
    <div className={styles.body}>
      <AnalyzerResultsHeader activeTab={activeTab} setActiveTab={setActiveTab} />
      {activeTab === AnalyzerTab.SELECTION && (
        <div className={styles.selectionContent}>
          <AnalyzerChecksForm />
        </div>
      )}
      {activeTab === AnalyzerTab.REPORT && (
        <div className={styles.reportContent}>{report ? <AnalyzerReport report={report} /> : <LoadingContainer />}</div>
      )}
      <AnalyzerActionBar />
    </div>
  );
};
